var _path, _path2, _rect, _circle, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNhnsolution3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 77,
    height: 76,
    viewBox: "0 0 77 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.114 21.9558C30.1729 21.0661 27.5286 18.0225 24.4559 18.0225L23.4486 18.0225C17.7665 17.6708 12.422 21.327 10.8543 27.0343L6.61772 42.4575C4.82038 49.0007 8.66765 55.762 15.2108 57.5593C21.754 59.3567 28.5154 55.5094 30.3127 48.9662L31.0531 46.2708C31.6494 44.0999 33.6232 42.5952 35.8745 42.5952H40.0366C42.288 42.5952 44.2617 44.0999 44.858 46.2708L45.5984 48.966C47.3957 55.5092 54.1571 59.3565 60.7002 57.5592C67.2434 55.7618 71.0907 49.0005 69.2934 42.4573L65.0568 27.0341C63.4888 21.3258 58.1428 17.6694 52.4596 18.0225V18.0225C49.3869 18.0225 46.7168 21.0661 43.7758 21.9558C43.3522 22.0839 42.9029 22.1528 42.4376 22.1528H34.4522C33.9868 22.1528 33.5375 22.0839 33.114 21.9558Z",
    fill: "#D9D9D9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.114 21.9558C30.1729 21.0661 27.5286 18.0225 24.4559 18.0225L23.4486 18.0225C17.7665 17.6708 12.422 21.327 10.8543 27.0343L6.61772 42.4575C4.82038 49.0007 8.66765 55.762 15.2108 57.5593C21.754 59.3567 28.5154 55.5094 30.3127 48.9662L31.0531 46.2708C31.6494 44.0999 33.6232 42.5952 35.8745 42.5952H40.0366C42.288 42.5952 44.2617 44.0999 44.858 46.2708L45.5984 48.966C47.3957 55.5092 54.1571 59.3565 60.7002 57.5592C67.2434 55.7618 71.0907 49.0005 69.2934 42.4573L65.0568 27.0341C63.4888 21.3258 58.1428 17.6694 52.4596 18.0225V18.0225C49.3869 18.0225 46.7168 21.0661 43.7758 21.9558C43.3522 22.0839 42.9029 22.1528 42.4376 22.1528H34.4522C33.9868 22.1528 33.5375 22.0839 33.114 21.9558Z",
    fill: "url(#paint0_linear_2137_19226)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24.5727,
    height: 40.5672,
    rx: 12.2863,
    transform: "matrix(-0.964282 0.264878 0.264878 0.964282 61.8027 15.1865)",
    fill: "#FF6060"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 23.4149,
    cy: 30.3089,
    r: 6.3211,
    stroke: "white",
    strokeWidth: 3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M53.4551 23.7842L53.4551 36.8337",
    stroke: "white",
    strokeWidth: 3
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M59.9824 30.3091L46.9329 30.3091",
    stroke: "white",
    strokeWidth: 3
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2137_19226",
    x1: 38.3245,
    y1: 25.9288,
    x2: -9.17046,
    y2: 32.7427,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFACAC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D26499"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNhnsolution3);
export default __webpack_public_path__ + "static/media/nhnsolution3.031071d46ae3a22fabf4a2195698efaf.svg";
export { ForwardRef as ReactComponent };